import {
  login,
  getPhoneCode,
  logout,
  choose,
  getPicValiCode,
  // checkCompanyExists,
  checkPhoneExists,
  getTelCode,
  register,
  userInfo,
  getCompanyInfo
} from '@/api/login-api.js'
import store from '@/store/index.js'

// 校验公司是否已注册
// export function companyIsExists(name) {
//   return checkCompanyExists(name).then(res => {
//     if (res.result === 1 && res.data.status === 'success') {
//       return false
//     } else {
//       return res.message || '校验已注册失败'
//     }
//   }).catch(err => false)
// }

// 校验电话是否已注册
export function phoneIsExists(name) {
  return checkPhoneExists(name).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return false
    } else {
      return res.message || '校验已注册失败'
    }
  }).catch(err => false)
}

// 注册服务
export function registerServer(data) {
  return register(data).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return true
    } else {
      return false
    }
  }).catch(err => false)
}

// 登录服务
export function loginServer(data) {
  return login({
    ...data,
    salt: new Date().valueOf()
  }).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      // 这里做一下刷新页面是否需要重定向最后一次登录人的当前页面的判断
      // 用于pre-init.js的initLocation方法
      let _old = window.localStorage.getItem('_last_staff_id')
      window.localStorage.setItem('_need_init_location', false)
      if (!_old) {
        window.localStorage.setItem('_last_staff_id', res.data.staffId)
      } else if (_old !== `${res.data.staffId}`) {
        window.localStorage.setItem('_last_staff_id', res.data.staffId)
        window.localStorage.setItem('_need_init_location', true)
      } else {
        window.localStorage.setItem('_last_staff_id', res.data.staffId)
      }

      return {
        loginIdentity: res.data.loginIdentity || 0,
        staffId: res.data.staffId
      }
    } else if (res.result === 1 && res.data.status === 'login_verify_random') { // 需要手机验证码验证
      return {
        ...res.data,
        _code: -2
      }
    } else if (res.result === 1 && res.data.status === 'login_verify_random_wrong') { // 手机验证码验证错误
      return {
        ...res.data,
        _code: -3
      }
    } else if(Number(res.data.result) === 20) { // 3次失败需要做的处理
      return {
        _code: -1,
        msg: res.data.msg
      }
    } else {
      return res.data.msg || res.message || '请求失败，请稍后重试'
    }
  }).catch(err => false)
}

// 登出服务
export function logoutServer() {
  return logout().then(res => {
    if (res.result === 1) {
      return true
    }
    return false
  }).catch(err => false)
} 

// 登录选择身份
export function loginChoose(data) {
  return choose(data).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return true
    } else {
      return false
    }
  }).catch(err => false)
}

// 获取验证码图片
export function getValiCodePicSrc(key) {
  return getPicValiCode(key).then(res => {
    if (res.result === 1) {
      return `data:image/png;base64,${res.data}`
    } else {
      return false
    }
  }).catch(err => false)
}

// 获取手机验证码
export function getTelValiCode(data) {
  return getTelCode(data).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return true
    } else {
      return false
    }
  }).catch(err => false)
}

// 先从服务端获取
// 服务端获取不到从本地拿
// 本地拿不到，报身份过期，跳登录
export async function loadUserInfo({f_local, isUnlogin} = {}) {
  if (f_local) {
    // 强制从本地拿身份信息，没有拿到就跳登录页
    let _loc_info = window.localStorage.getItem('userinfo')
    if (_loc_info && _loc_info !== "{}") {
      _loc_info = JSON.parse(_loc_info);
      store.dispatch("setUserInfo", _loc_info)
      store.dispatch("setMenuConf", _loc_info.menuConf)
      return true
    } else {
      !isUnlogin && store.dispatch("LOGOUT")
      return false
    }

  } else {
     try {
      const serverRes = await userInfo();
      if (serverRes.result === 1) {
        console.log(serverRes)
        store.dispatch('setUserInfo', serverRes.data)
        store.dispatch('setMenuConf', serverRes.data.menuConf)
        console.log(serverRes)
        return true
      } else {
        // 从本地拿
        let _loc_info = window.localStorage.getItem('userinfo')
        if (_loc_info && _loc_info !== "{}") {
          _loc_info = JSON.parse(_loc_info);
          store.dispatch("setUserInfo", _loc_info)
          store.dispatch("setMenuConf", _loc_info.menuConf)
          return true
        } else {
          !isUnlogin && store.dispatch("LOGOUT")
          return false
        }
      }
    } catch (error) {
      console.log(error)
      store.dispatch("LOGOUT")
      return false
    }
  }
 
}

export const phoneCodeGet = function(params) {
  return getPhoneCode(params).then(res => {
    if (res.result === 1 && res.data.status === 'success') {
      return res.data.phoneNum
    } else {
      return false
    }
  }).catch(err => false)
};
